import Methods from './methods'
export default Methods
